export enum LoggingLevel {
  trace = 'trace',
  warn = 'warn',
  error = 'error',
  off = 'off',
}
